import React from 'react';
import Select from 'react-select'
import {useTranslation} from 'react-i18next';


function Input(props) {
	const {t} = useTranslation();
	let {
		label = '',
		name = '',
		required = false,
		updateItem = () => {
		},
		item = {},
		isError = false,
		onValide = false,
		display = {},
		components = {},
		options = []
	} = props;

	let paramsInput = {}
	if ((isError || onValide) && required) {
		paramsInput = {
			required: true
		};
	}

	let value = typeof item[name] !== 'undefined' ? item[name] : '';
	return (
		<div className={
			'mb-3' +
			(((isError || onValide) && required) ? ' was-validated' : '')
		}>
			{
				(
					(typeof display.label === 'undefined') ||
					(typeof display.label !== 'undefined' && display.label)
				) && (
					<label className="form-label">
						{label} {required && (<span>*</span>)}
					</label>
				)
			}
			<Select
				options={options}
				value={{value, label: value}}
				onChange={(val) => {
					updateItem(name, val.value);
				}}
				{...paramsInput}
			/>
			<div className="invalid-feedback">{t('Form.required')}</div>
			{typeof components.footer !== 'undefined' ? components.footer : (null)}
		</div>
	);
}

export default Input;
